export function parseTableBlueprint(string) {
  const [headers, ...lines] = string.split('\n');
  return {
    headers: parsedLine(headers),
    rows: lines.map(parsedLine)
  };
}

function parsedLine(line) {
  const headers = new Headers();

  // Regex copied from https://github.com/lezer-parser/markdown/blob/48c82f1a5544ee713a512efa42879253c7593883/src/markdown.ts
  // to reflect what is considered an Entity.

  line.split(/(&(?:#\d+|#x[a-f\d]+|\w+);)/i)
    .forEach((chunk, index) => {
      if (index % 2 === 0) {
        chunk.split(/[;|]/)
          .forEach((piece, index) => {
            if (index > 0) {
              headers.commit();
            }
            headers.append(piece);
          });
      } else {
        headers.append(chunk);
      }
    });

  return headers.asArray();
}

class Headers {
  constructor() {
    this.headers = [];
    this.consumed = '';
  }

  append(string) {
    this.consumed += string;
  }

  commit() {
    this.headers.push(this.consumed.trim());
    this.consumed = '';
  }

  asArray() {
    return [...this.headers, this.consumed.trim()];
  }
}
